module.exports = {
	"copy": {
		"header": "Save Beautiful Things",
		"text": "Save this item to create a collection of your Favorites.",
		"mobileText": "Tap to save in your favorites."
	}
};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Favorites/PdpFavoriteItemCallout.json
// module id = 2578
// module chunks = 4